import { useMutation } from '@tanstack/react-query';

import { WosIsiReportParams, WosIsiReportType } from '@/module/WosIsiReport/model/WosIsiReportTypes';

import { saveBlobResponse } from '@feature/utils';

import * as api from './WosIsiReportApi';

function fallbackFilename(type: WosIsiReportType, params: WosIsiReportParams) {
  const name = type === 'isi-articles' ? 'articole-isi' : 'rezumate-isi';

  return `${name}-${params.startYear}-${params.endYear}.xlsx`;
}

export function useGenerateWosIsiReport(type: WosIsiReportType) {
  return useMutation({
    mutationFn: async (params: WosIsiReportParams) => {
      const response = await api.generateWosIsiReport(type, params);
      saveBlobResponse(response, fallbackFilename(type, params));
    },
  });
}
